import React, { useState, useEffect } from 'react';
import { Alert, Button, Container } from 'react-bootstrap';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('cookieConsent');
    if (!hasAccepted) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent-wrapper">
      <Container>
        <Alert variant="info" className="cookie-alert">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="mb-0">
                This website uses cookies to enhance your experience and enable features like Google login. 
                By continuing to use this site, you agree to our use of cookies.
              </p>
            </div>
            <Button variant="primary" onClick={handleAccept} className="ml-3">
              Accept
            </Button>
          </div>
        </Alert>
      </Container>
    </div>
  );
};

export default CookieConsent;